import kacchiBiriyani from "../../../../images/biriyanijpg.jpg";
export const biriyaniData = [
  {
    name: "Hyderabadi Biryani",
    image: kacchiBiriyani,
    price: "40.00",
    description: "chicken,BBQ sauce,tomato",
  },

  {
    name: "Keema Biryani",
    image: kacchiBiriyani,
    price: "130.10",
    description: "beef patty, BBQ sauce,",
  },
  {
    name: "Awadhi Mutton Biryani",
    price: "15.00",
    deletedprice: ".200",
    description: "cheese,Naga",
  },
  {
    name: "Chicken Reshmi Biryani",
    image: kacchiBiriyani,
    price: "15.00",
    deletedprice: ".200",
    description: "cheese,Naga",
  },
  {
    name: "Makhni Paneer Biryani",
    image: kacchiBiriyani,
    price: "15.50",
    deletedprice: ".20",
    description: "cheese,Naga",
  },
];
